import type { StateType } from '../reducers';

export const themeNameSelector = (state: StateType): string => state.theme;
